import React from 'react';
import styled from 'styled-components';

const HandleWrapper = styled.div`
  height: 1rem;
  margin: auto 0 auto 0;
  display: inline-block;
  text-align: center;
  div > i {
    width: 100%;
    height: 100%;
  }
  cursor: ${({isDragging}) => (isDragging ? 'grabbing' : 'grab')};
`;

const HandleGrab = styled.div`
  margin: auto 0 auto;
  height: 50px;
  display: flex;
  justify-content: center;
  cursor: ${({isDragging}) => (isDragging ? 'grabbing' : 'grab')};
`;

export const DragHandle = props => {
  return (
    <HandleGrab
      className="text-center"
      {...props}
    >
      <HandleWrapper {...props}>
        <i className="fa fa-align-justify" />
      </HandleWrapper>
    </HandleGrab>
  );
};
